import styled from 'styled-components';

export const ReportMeta = styled.section`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px 32px;
`;

export const ReportMetaGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ReportMetaRow = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 110px 1fr;
  font-size: 14px;
  line-height: 20px;
`;

export const CategoriesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;
